import { useEffect, useState } from 'react'
import type { Stripe } from '@stripe/stripe-js'
import { loadStripe } from '@stripe/stripe-js'

export const useStripe = (publishableKey: string): Promise<Stripe> => {
  const [stripe, setStripe] = useState(null)

  useEffect(() => {
    setStripe(loadStripe(publishableKey))
  }, [publishableKey])

  return stripe
}
